/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Domain} from './Domain';

/**
 * The PropertiesBody model module.
 * @module model/PropertiesBody
 * @version 1.0.0
 */
export class PropertiesBody {
  /**
   * Constructs a new <code>PropertiesBody</code>.
   * @alias module:model/PropertiesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PropertiesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PropertiesBody} obj Optional instance to populate.
   * @return {module:model/PropertiesBody} The populated <code>PropertiesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PropertiesBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('shortcode'))
        obj.shortcode = ApiClient.convertToType(data['shortcode'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('domains'))
        obj.domains = Domain.constructFromObject(data['domains']);
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
PropertiesBody.prototype.title = undefined;

/**
 * @member {String} shortcode
 */
PropertiesBody.prototype.shortcode = undefined;

/**
 * @member {String} description
 */
PropertiesBody.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
PropertiesBody.prototype.enabled = undefined;

/**
 * @member {module:model/Domain} domains
 */
PropertiesBody.prototype.domains = undefined;

